import { uniqueContext } from "@tastyworks/ui-library"
import { generateSessionCode } from "./cobrowse"

export class CobrowseSessionStore {
  sessionCode = $state<string | null>(null)
  sessionLoading = $state(false)

  async requestSessionCode(onError?: (error: unknown) => void): Promise<void> {
    if (this.sessionLoading) return
    this.sessionLoading = true
    try {
      this.sessionCode = await generateSessionCode()
    } catch (error) {
      onError?.(error)
    } finally {
      this.sessionLoading = false
    }
  }
}

const { getContext, setContext } =
  uniqueContext<CobrowseSessionStore>("cobrowse-session")

export const getCobrowseSessionContext = getContext
export function setCobrowseSessionContext() {
  setContext(new CobrowseSessionStore())
}
